import React, { useMemo } from "react";
import { useDataWithRoute } from "../utils/hooks";
import { VsiBubble } from "../styled/App.styled";
import DumbbellSeries from "../components/DumbbellSeries";
import { Spinner } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";

export default function BackupRuntime(args) {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("BACKUP");

  const route = useMemo(() => `/api/v6/report/backup_run_time_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const { chartData, scrollHeight } = useMemo(() => {
    // cleaned this up to make one pass through recordset
    const grouped = {};

    for (let datum of recordset) {
      if (!grouped[datum.backup_job_name]) {
        grouped[datum.backup_job_name] = {
          runtimes: [],
          datum: datum
        };
      }
      if (datum.runtime >= 0) {
        grouped[datum.backup_job_name].runtimes.push(datum.runtime);
      }
    }

    const lowToHigh = Object.values(grouped).map(({ datum }) => ({
      name: datum.backup_job_name,
      staticLow: datum.shortest_run_time,
      low: datum.shortest_run_time,
      mid: datum.most_recent_run_time,
      high: datum.longest_run_time
    }));

    const sortedResult = Object.entries(grouped).map(([name, { runtimes }]) => ({
      name,
      low: Math.min(...runtimes),
      high: Math.max(...runtimes)
    }));

    return {
      chartData: {
        name: "Backup Runtime",
        data: lowToHigh,
        lowColor: "#B0EA3B"
      },
      scrollHeight: sortedResult.length * 20
    };
  }, [recordset]);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubble>
      <DumbbellSeries series={chartData}
                      yTitle={"Runtime (mins)"}
                      xTitle={"Job Name"}
                      height={380}
                      formatPoint={`{series.name}: {point.low} - {point.high} min(s)`}
                      scrollHeight={scrollHeight} />
    </VsiBubble>
  );
}